module.exports = __webpack_public_path__ + "img/m-item03.44388ba.png";